import { Components } from '@mui/material';

type ReturnType = Record<'MuiAvatarGroup', Components['MuiAvatarGroup']>;

export default function AvatarGroup(): ReturnType {
  return {
    MuiAvatarGroup: {
      styleOverrides: {
        root: ({ ownerState: { max } }) => ({
          ...[...Array(max)].reduce((result, _curr, index) => ({
            ...result,
            [`& > .MuiAvatar-root:nth-of-type(${index + 1})`]: {
              zIndex: -1,
            },
          })),
        }),
      },
    },
  };
}
